export const DEFAULTS = {
    teacher: {
        accountState: 'incomplete',
    },
    school: {
        accountState: 'pendingApproval',
        userAccountState: 'pendingSchoolAdminApproval',
        userAuthority: 'bookingAssistant',
    },
} as const
